import { render, staticRenderFns } from "./paginaRaiz.vue?vue&type=template&id=dd232e7c&"
import script from "./paginaRaiz.vue?vue&type=script&lang=js&"
export * from "./paginaRaiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports